import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const myRouter = new Router({
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      redirect: '/ticket'
    },
    {
      path: '/ticket',
      name: 'ticket',
      component: () => import('@/views/Ticket/index')
    },
    {
      path: '/cart',
      name: 'cart',
      component: () => import('@/views/Ticket/Cart')
    },
    {
      path: '/ticketOrder/:id',
      name: 'ticketOrder',
      meta: {
        requireAuth: true
      },
      component: () => import('@/views/Ticket/TicketOrder')
    },
    {
      path: '/batchTicketOrder/:id',
      name: 'batchTicketOrder',
      meta: {
        requireAuth: true
      },
      component: () => import('@/views/Ticket/BatchTicketOrder')
    },
    {
      path: '/member',
      name: 'member',
      component: () => import('@/views/Member/MemberList')
    },
    {
      path: '/memberOrder',
      name: 'memberOrder',
      meta: {
        requireAuth: true
      },
      component: () => import('@/views/Member/MemberOrder')
    },
    {
      path: '/ticketPay/:id',
      name: 'ticketPay',
      meta: {
        requireAuth: true
      },
      component: () => import('@/views/Pay')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/LoginPage/PhoneLogin')
    },
    {
      path: '/myOrder',
      name: 'myOrder',
      meta: {
        requireAuth: true
      },
      component: () => import('@/views/MyOrder')
    }
  ]
})

myRouter.beforeEach((to, from, next) => {
  const project = from.query.project

  if (to.meta && to.meta.requireAuth && !localStorage.getItem('tmly_username')) {
    next({
      name: 'login',
      params: {
        from: to.name
      },
      query: { project }
    })
  } else {
    next()
    if (to.query.project) {
      next()
    } else {
      if (project) {
        next({ path: to.path, query: { project } })
      } else {
        next()
      }
    }
  }
})
export default myRouter
